<template>
  <el-dialog title="修改公告" :visible.sync="noticeDetailDialogVisible" @close="closeDialog">
    <el-form :model="noticeDetail" ref="form" label-width="140px" class="notice-form">
      <!-- <el-form-item
        label="类型："
        prop="type"
        :rules="[
            { required: true, message: '类型不能为空'}
          ]"
      >
        <el-select :value="noticeDetail.type" placeholder="请选择">
          <el-option
            v-for="item in noticeTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="标题：" prop="title">
        <div v-for="lang in languageList" :key="lang.value">
          （{{lang.label}}标题）
          <el-input
            type="text"
            :value="noticeDetail.title[lang.value]"
            auto-complete="off"
            @change="handleSetNoticeDetail('title', lang.value, $event)"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item prop="content" label="内容：">
        <div v-if="noticeDetail.type === 2" v-for="lang in languageList" :key="lang.value">
          （{{lang.label}}内容）
          <editor
            :value="noticeDetail.content[lang.value]"
            class="editor"
            @change="handleSetNoticeDetail('content', lang.value, $event)"
          ></editor>
        </div>
        <div v-if="noticeDetail.type === 1" v-for="lang in languageList" :key="lang.value">
          （{{lang.label}}内容）
          <upload
            url="/admin/notice/upload"
            :data="{language: lang.value}"
            :value="noticeDetail.content[lang.value]"
            @change="handleSetNoticeDetail('content', lang.value, $event)"
          ></upload>
        </div>
      </el-form-item>
      <el-form-item prop="url" label="跳转链接：">
        <el-input :value="noticeDetail.url" @change="handleSetNoticeDetail('url', null, $event)"></el-input>
      </el-form-item>

      <el-form-item prop="clientType" label="客户端类型">
        <el-select v-model="noticeDetail.clientType" placeholder="请选择客户端">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>

        <el-form-item label="通知名称">
          <el-input v-model="noticeDetail.noticeName"></el-input>
        </el-form-item>

      <el-form-item label="有效期">
          <el-date-picker v-model="noticeDetail.validTime" type="datetime" placeholder="选择日期"> </el-date-picker>
        </el-form-item>

      <el-form-item label="显示频率时间段（单位：分钟）">
        <el-input v-model="noticeDetail.viewIntervalMinutes"></el-input>
      </el-form-item>

      <el-form-item label="显示次数">
        <el-input v-model="noticeDetail.viewCount"></el-input>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave('form')">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Editor from "components/editor";
import Upload from "components/upload";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "UpdateNotice",
  data(){
    return {
      options: [{value: 1, label: "PC端"}, {value: 2, label: "移动端"}],
    }
  },
  components: {
    Editor,
    Upload
  },
  computed: {
    ...mapState("notice", [
      "languageList",
      "noticeTypes",
      "noticeDetailDialogVisible",
      "noticeDetail"
    ])
  },
  methods: {
    ...mapActions("notice", ["update"]),
    ...mapMutations("notice", [
      "setNoticeDetailDialogVisible",
      "setNoticeDetail"
    ]),
    closeDialog() {
      this.setNoticeDetailDialogVisible(false);
    },
    handleSetNoticeDetail(type, key, value) {
      this.setNoticeDetail({
        ...this.noticeDetail,
        [type]:
          type === "url" ? value : { ...this.noticeDetail[type], [key]: value }
      });
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {

          if(isNaN(this.noticeDetail.viewIntervalMinutes) || isNaN(this.noticeDetail.viewCount)) {
            this.$message.error('显示频率时间段和显示次数必须为数字');
            return;
          }

          let warnText = this.noticeDetail.viewIntervalMinutes < 60 ? this.noticeDetail.viewIntervalMinutes + '分钟显示' + this.noticeDetail.viewCount + '次'
                  : this.noticeDetail.viewIntervalMinutes/60 + '小时显示' + this.noticeDetail.viewCount + '次';

          this.$confirm(warnText,'提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() =>{
            this.update(this.noticeDetail).then(() => {
              this.$message({
                message: "修改成功！",
                type: "success"
              });
              this.setNoticeDetailDialogVisible(false);
              this.$emit("refresh");
            });
          }).catch(() =>{
            this.$message.info('已取消');
          })
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.announcement-form {
  margin-right: 100px;
}
.editor {
  height: 500px;
}
</style>
